import { queryClient, trpc } from "../../app/trpc.js";

/** После любого действия с записью обновить календарь, карточку записи, диалог и карточку клиента. */
export function invalidateBookings(): void {
  void queryClient.invalidateQueries(trpc.cabinet.agenda.pathFilter());
  void queryClient.invalidateQueries(trpc.cabinet.contacts.pathFilter());
  void queryClient.invalidateQueries(trpc.cabinet.conversation.pathFilter());
  void queryClient.invalidateQueries(trpc.calendar.pathFilter());
}
